import { useCurrentCompanyId } from '@/hooks/useCurrentCompanyId';

export const EmailDashboard = () => {
  const token = localStorage.getItem(`token`);
  const idCompany = useCurrentCompanyId();

  return (
    <div>
      <iframe
        style={{
          border: `none`,
          padding: `0`,
          margin: `0`,
          height: `calc(100vh - 70px)`,
        }}
        title="Email"
        src={`https://tradersclub.retool.com/embedded/public/28e4631d-fa99-4046-9b0e-0a8850ce01dc#token=${token}&companyId=${idCompany}`}
        width="100%"
      />
    </div>
  );
};
